"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var prop_types_1 = __importDefault(require("prop-types"));
function Logo(_a) {
    var image = _a.image;
    return react_1.default.createElement("img", { className: 'storybook-channels-logo-image', src: image, alt: 'image' });
}
exports.default = Logo;
Logo.propTypes = {
    image: prop_types_1.default.string
};
